import { KeypadOptions } from "../types";

export const emailPadOptions: KeypadOptions = [
  {
    label: "@gmail.com",
    value: "@gmail.com",
  },
  {
    label: "@outlook.com",
    value: "@outlook.com",
  },
  {
    label: "@yahoo.com",
    value: "@yahoo.com",
  },
];
